import React, { createContext, useState, useEffect } from 'react';

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
    const [loginResult, setLoginResult] = useState(() => {
        // Initialize state from localStorage if available
        const saved = localStorage.getItem('loginResult');
        return saved ? JSON.parse(saved) : null;
    });
    console.log('Initial Login Result:', loginResult);

    useEffect(() => {
        // Sync loginResult to localStorage whenever it changes
        if (loginResult) {
            localStorage.setItem('loginResult', JSON.stringify(loginResult));
        } else {
            localStorage.removeItem('loginResult');
        }
    }, [loginResult]);

    const login = (data) => {
        setLoginResult(data);
    };

    const logout = () => {
        setLoginResult(null);
    };

    return (
        <LoginContext.Provider value={{ loginResult, login, logout }}>
            {children}
        </LoginContext.Provider>
    );
};
